export const ReportType = {
    RSO : {reportType: 'RSO', title: 'RSO Level'},
    MATERIAL_INVENTORY : {reportType: 'MATERIAL_INVENTORY', title: 'Material Level (Inventory)'},
    MATERIAL_FINANCE : {reportType: 'MATERIAL_FINANCE', title: 'Material Level (Finance)'}
}
